import styled from "styled-components";

export const CMBCTAWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const CMBCTAContainer = styled.div`
  padding: 10px;
  border-radius: 100vw;
  background-color: ${({ theme }) => theme.colors.brand["700"]};
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CTAMessageHeading = styled.h5`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.white};
`;

export const CTAMessageSubHeading = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;

export const StyledChevron = styled.div`
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
`;
